import React from 'react';
import Relay from 'react-relay/classic';
import PropTypes from 'prop-types';

import { trackEvent } from 'dibs-tracking';
import { SAVE_ITEM_FLOW } from 'dibs-buyer-layout/src/authModal/authentication/authFlowConstants';
import userHelper from '../../../global/core/commonjs/userHelper';

import HeartComponent from 'dibs-portfolio-heart';

import styles from './RelatedFavoriteItem-style.scss';

class RelatedFavoriteItem extends React.Component {
    constructor(props) {
        super(props);

        this.alreadyForced = false;
        this.authModalShow = this.authModalShow.bind(this);
        this.onFavorited = this.onFavorited.bind(this);
        this.onUnFavorited = this.onUnFavorited.bind(this);
    }

    authModalShow(favoriteItem) {
        const { gridType, title, image } = this.props;
        const item = {
            title,
            firstPhotoWebPath: image,
        };

        userHelper
            .checkLogin(
                {
                    label: `save item - product page - ${gridType}`,
                },
                SAVE_ITEM_FLOW,
                false,
                { item }
            )
            .then(favoriteItem);
    }

    onFavorited() {
        this.trackFavoriting('item added');

        if (this.props.onFavorited) {
            this.props.onFavorited();
        }
    }

    onUnFavorited() {
        this.trackFavoriting('item removed');
    }

    trackFavoriting(action) {
        const { gridType } = this.props;

        trackEvent({
            action,
            label: `PDP - ${gridType}`,
            category: 'item favoriting',
        });
    }

    render() {
        const { viewer, itemId, loadPortfolioData, selectedItemIds, userId, userIds } = this.props;

        return (
            <div className={styles.pdpHeartItem}>
                <HeartComponent
                    itemId={itemId}
                    loadPortfolioData={loadPortfolioData}
                    selectedItemIds={selectedItemIds}
                    userId={userId}
                    userIds={userIds}
                    viewer={viewer}
                    // handlers
                    authModalShow={this.authModalShow}
                    onFavorited={this.onFavorited}
                    onUnFavorited={this.onUnFavorited}
                />
            </div>
        );
    }
}

RelatedFavoriteItem.propTypes = {
    loadPortfolioData: PropTypes.bool,
    selectedItemIds: PropTypes.array.isRequired,
    gridType: PropTypes.string.isRequired,
    title: PropTypes.string,
    image: PropTypes.string,
    userId: PropTypes.string,
    userIds: PropTypes.array,
    itemId: PropTypes.string,
    viewer: PropTypes.object,
    onFavorited: PropTypes.func,
};

module.exports = Relay.createContainer(RelatedFavoriteItem, {
    initialVariables: {
        loadPortfolioData: false,
        selectedItemIds: [],
        userId: null,
        userIds: [],
    },
    fragments: {
        viewer: params => Relay.QL`
                fragment on Viewer {
                    ${HeartComponent.getFragment('viewer', params)}
                }
            `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Favorites/RelatedFavoriteItem.jsx